import { render, staticRenderFns } from "./CartPayment.vue?vue&type=template&id=349914b4&scoped=true&"
import script from "./CartPayment.vue?vue&type=script&lang=js&"
export * from "./CartPayment.vue?vue&type=script&lang=js&"
import style0 from "./CartPayment.vue?vue&type=style&index=0&id=349914b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349914b4",
  null
  
)

export default component.exports